/* ============================================================
   MORNING FIX COFFEE
   BUILD #3 — SHOPIFY PRODUCT / VARIANT CONFIGURATION
   VERSION 1.0.1
   ============================================================

   RESPONSIBILITY
   ------------------------------------------------------------
   Connect Build #2 logical product keys to real Shopify
   product / variant information.

   Build #3 DOES NOT:
   • calculate quiz results
   • determine roast profiles
   • select landing pages
   • add products to cart
   • create subscriptions
   • render UI

   Build #1 = Profile Engine
   Build #2 = Landing Page Router
   Build #3 = Shopify Product Configuration
   Build #4 = Cart Operations

   IMPORTANT
   ------------------------------------------------------------
   "available" is derived from the presence of a variantId.

   variantId exists
       → available = true

   variantId missing
       → available = false

   This prevents availability from drifting out of sync with
   the actual Shopify configuration.

   ============================================================ */


const CoffeeShopifyProducts = (function () {


  /* ==========================================================
     1. SHOPIFY PRODUCT CONFIGURATION
     ==========================================================

     IMPORTANT:
     Replace the empty productId / variantId values with the
     ACTUAL Shopify IDs when they are available.

     Do NOT invent IDs.

     ========================================================== */

  const PRODUCTS = {

    medium_light: {
  key: "medium_light",
  name: "Medium-Light Roast",
  productId: "",
  variantId: "47145597272213",
  image: "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/19a0343c-d6f3-474b-8e67-db6066a11fac_7afa7cf5-7de2-482d-8d45-fcb9cbbbc334.png?v=1786484893"
},

medium: {
  key: "medium",
  name: "Medium Roast",
  productId: "",
  variantId: "47145585967253",
  image: "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/40a21cdd-3bbf-41cf-b7e9-00c0a52378eb_9129ac44-68bf-448d-b446-d5a237493f8a.png?v=1786485601"
},

medium_dark: {
  key: "medium_dark",
  name: "Medium-Dark Roast",
  productId: "",
  variantId: "47145649504405",
  image: "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/59a6d5a5-717d-4e88-956f-f19d372ebeaa_18ab219a-e44e-43e5-8bff-7da4b09269b0.png?v=1786485790"
},

dark: {
  key: "dark",
  name: "Dark Roast",
  productId: "",
  variantId: "47145828384917",
  image: "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/4594d29e-6178-4eeb-bd69-57dd2fd608c1_81400821-4898-4b25-8912-81446ad34a69.png?v=1786485296"
}

  };


  /* ==========================================================
     1B. BUY BOTH COMPOSITE ARTWORK
     ==========================================================

     Dedicated composite images for the three transition
     purchase options — not the two individual roast images
     side by side. Keyed by "productKeyA+productKeyB", matching
     the order Build 2's LANDING_PAGES config always lists each
     transition pair in (ascending roast order).

     ========================================================== */

  const BOTH_IMAGES = {

    "medium_light+medium":
      "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/Medium-Light_Medium_Buy_Both.png?v=1787355840",

    "medium+medium_dark":
      "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/Medium_Medium-Dark_Buy_Both.png?v=1787355840",

    "medium_dark+dark":
      "https://cdn.shopify.com/s/files/1/0774/7656/1045/files/Medium-Dark_Dark_Buy_Both.png?v=1787355840"

  };


  /* ==========================================================
     2. PRODUCT AVAILABILITY
     ========================================================== */

  function isAvailable(product) {

    return Boolean(
      product &&
      product.variantId
    );

  }


  /* ==========================================================
     3. PRODUCT LOOKUP
     ========================================================== */

  function getProduct(productKey) {

    const product =
      PRODUCTS[productKey];


    if (!product) {

      throw new Error(
        "Shopify product not found: " +
        productKey
      );

    }


    return product;

  }


  /* ==========================================================
     4. GET VARIANT ID
     ==========================================================

     This is intentionally strict.

     Build #4 will use this function when an actual cart
     operation is requested.

     ========================================================== */

  function getVariantId(productKey) {

    const product =
      getProduct(
        productKey
      );


    if (!product.variantId) {

      throw new Error(
        "No Shopify variant ID configured for: " +
        productKey
      );

    }


    return product.variantId;

  }


  /* ==========================================================
     5. GET PRODUCT INFORMATION
     ========================================================== */

  function getProductInfo(productKey) {

    const product =
      getProduct(
        productKey
      );


    return {

      key:
        product.key,

      name:
        product.name,

      productId:
        product.productId,

      variantId:
        product.variantId,

      image:
        product.image,

      available:
        isAvailable(product)

    };

  }


  /* ==========================================================
     6. RESOLVE PURCHASE OPTION
     ==========================================================

     Takes the logical purchase option produced by Build #2
     and attaches Shopify configuration.

     No cart operation occurs here.

     ========================================================== */

  function resolvePurchaseOption(option) {

    if (!option) {

      throw new Error(
        "Purchase option is required."
      );

    }


    /* ========================================================
       SINGLE PRODUCT
       ======================================================== */

    if (
      option.type === "single"
    ) {

      const product =
        getProduct(
          option.key
        );


      return {

        key:
          option.key,

        name:
          option.name,

        type:
          "single",

        productId:
          product.productId,

        variantId:
          product.variantId,

        image:
          product.image,

        available:
          isAvailable(product)

      };

    }


    /* ========================================================
       BOTH PRODUCTS
       ======================================================== */

    if (
      option.type === "both"
    ) {

      if (
        !Array.isArray(
          option.products
        ) ||
        option.products.length !== 2
      ) {

        throw new Error(
          "A Both option must contain exactly two products."
        );

      }


      const pairKey =
        option.products.join("+");


      const products =
        option.products.map(
          function(productKey) {

            return getProductInfo(
              productKey
            );

          }
        );


      return {

        key:
          "both",

        name:
          "Buy Both",

        type:
          "both",

        image:
          BOTH_IMAGES[pairKey] || "",

        products:
          products

      };

    }

    const BOTH_VARIANTS = {

  "medium_light+medium": [
    "47145597272213",
    "47145585967253"
  ],

  "medium+medium_dark": [
    "47145585967253",
    "47145649504405"
  ],

  "medium_dark+dark": [
    "47145649504405",
    "47145828384917"
  ]

};

    /* ========================================================
       UNKNOWN OPTION
       ======================================================== */

    throw new Error(
      "Unknown purchase option type: " +
      option.type
    );

  }


  /* ==========================================================
     7. RESOLVE LANDING PAGE
     ==========================================================

     Build #2 supplies the landing-page result.

     Build #3 attaches Shopify product information to every
     purchase option.

     ========================================================== */

  function resolveLandingPage(
    landingPageResult
  ) {

    if (!landingPageResult) {

      throw new Error(
        "Landing page result is required."
      );

    }


    if (
      !Array.isArray(
        landingPageResult.purchaseOptions
      )
    ) {

      throw new Error(
        "Landing page result contains no purchase options."
      );

    }


    return {

      resultId:
        landingPageResult.resultId,

      resultName:
        landingPageResult.resultName,

      landingPage:
        landingPageResult.landingPage,

      landingPageName:
        landingPageResult.landingPageName,

      landingPageType:
        landingPageResult.landingPageType,

      purchaseOptions:
        landingPageResult.purchaseOptions.map(
          resolvePurchaseOption
        )

    };

  }


  /* ==========================================================
     8. VALIDATE PRODUCT CONFIGURATION
     ========================================================== */

  function validate() {

    const requiredProducts = [

      "medium_light",
      "medium",
      "medium_dark",
      "dark"

    ];


    requiredProducts.forEach(
      function(productKey) {

        const product =
          PRODUCTS[productKey];


        /* ----------------------------------------------------
           Product must exist
           ---------------------------------------------------- */

        if (!product) {

          throw new Error(
            "Missing Shopify product configuration: " +
            productKey
          );

        }


        /* ----------------------------------------------------
           Product key must match
           ---------------------------------------------------- */

        if (
          product.key !==
          productKey
        ) {

          throw new Error(
            "Product key mismatch: " +
            productKey
          );

        }


        /* ----------------------------------------------------
           Product name required
           ---------------------------------------------------- */

        if (!product.name) {

          throw new Error(
            "Missing product name: " +
            productKey
          );

        }

      }
    );


    /* ========================================================
       RETURN CONFIGURATION STATUS
       ======================================================== */

    return {

      valid: true,

      productCount:
        requiredProducts.length,

      configuredVariants:
        requiredProducts.filter(
          function(productKey) {

            return isAvailable(
              PRODUCTS[productKey]
            );

          }
        ).length

    };

  }


  /* ==========================================================
     9. PUBLIC API
     ========================================================== */

  return {

    version: "1.0.1",

    build: 3,

    isAvailable,

    getProduct,

    getVariantId,

    getProductInfo,

    resolvePurchaseOption,

    resolveLandingPage,

    validate

  };

})();


/* ============================================================
   10. INITIAL VALIDATION
   ============================================================ */

CoffeeShopifyProducts.validate();


/* ============================================================
   11. GLOBAL EXPORT
   ============================================================ */

if (
  typeof window !== "undefined"
) {

  window.CoffeeShopifyProducts =
    CoffeeShopifyProducts;

}


/* ============================================================
   END BUILD #3
   ============================================================ */